import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const Circle = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '100%'
}));
